// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colSegment {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n.colSegment .avatar {\n  order: 2;\n}\n.colSegment .segment {\n  order: 1;\n}\n\n@media screen and (min-width: 478px) {\n  .colSegment .avatar {\n    order: 1;\n  }\n  .colSegment .segment {\n    order: 2;\n  }\n}\n.bg {\n  --background: #fafafa;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
